import { serverBus } from '@/main';
import Socket from '@/classes/WebSocket';
import SessionManager from '@/Manager/Session.manager';
import { Logging } from '@/scripts/Logging';
import Config from '@/scripts/config'
import VueSignals from '@/scripts/VueSignals';
import router from '@/router';
import UserApi from '@/scripts/api/user.api';
import FileApi from '@/scripts/api/file.api';
import config from '@/scripts/config';
import $cookies from 'vue-cookies'


let sessionId = ''
let ActionAnalytics = []
let clientAgent = ''
let isLoggedIn = true
let openMenuPosition = ''
let alr = ''
let mobileClientVersion = ''
let folderContent = []

export default class Global {
  constructor(){
    return new Global()
  }

  // window.location.href.indexOf('192.168')

  static GetDomainURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.DOMAIN_TEST
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.DOMAIN_STAGE
    }

    return Config.DOMAIN_PROD
  }

  static GetAPIURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.API_TEST
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.API_STAGE
    }

    return Config.API_PROD
  }

  static GetWSS(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.TEST_WSS
    }

    return Config.PRDO_WSS
  }


  static isDevelop(){
    if( window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return true
    }
    return false
  }

  static isTest(){
    if(window.location.hostname.indexOf('test') > -1  ||
    window.location.href.indexOf('192.168')){
      return true
    }
    return false
  }

  static isStage(){
    if(window.location.hostname.indexOf('stage') > -1 ){
      return true
    }
    return false
  }


  static getSessionID(){
    if(sessionId != null && sessionId.length > 0){
      return sessionId
    }
    return $cookies.get('sessionId')
  }

  static setSessionID(id){
    sessionId = id
    $cookies.set('sessionId', id)
  }

  static globalValue (catchKey, catchValue){
    if(typeof catchValue != 'undefined'){
      if(catchKey == "sessionId"){
        sessionId = catchValue
      }
      if(catchKey == "sessionId" || catchKey == "loggedIn" || catchKey == "login_token"){
        if($cookies.isKey(catchKey)){
          $cookies.remove(catchKey)
        }
        $cookies.set(catchKey, catchValue)
      }
      serverBus.$emit(catchKey, catchValue)
      sessionStorage.setItem(catchKey, catchValue)
      Logging.Signal(catchKey , catchValue)
    }
  }

  static getGlobalSessionValue(catchKey){
    let data = ''
    if(typeof serverBus != 'undefined' && typeof sessionStorage.getItem(catchKey) != 'undefined'){
      data = sessionStorage.getItem(catchKey)
    }
    return data;
  }

  static getGlobalValue(catchKey){
    let data = null
    serverBus.$on(catchKey, (res) => {
      return res
    });
    return data
  }

  static SaltID(digits = 5) {
    let ID = ""
    var odds = "0123456789ABCDEF"
      for(var i=0;i < digits ;i++){
        ID += odds.charAt(Math.floor(Math.random() * odds.length))
      }
      return ID
  }

  static GetUniServerURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.API_TEST_LB
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.API_STAGE_LB
    }

    return Config.API_PROD_LB
  }


  static GetChatURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.chatTestURL
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.chatStageURL
    }
    return Config.chatProdURL
  }

  static GetPortalURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.portalTestURL
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.portalStageURL
    }

    return Config.portalProdURL
  }


  static GetUniAPIURL(){
    if(window.location.hostname.indexOf('test') > -1 ||
        window.location.hostname.indexOf(Config.LocalIP) > -1 ||
        window.location.hostname.indexOf(Config.LocalHost) > -1){
      return Config.portalTestAPI
    }

    if(window.location.hostname.indexOf('stage') > -1){
      return Config.portalStageAPI
    }
    return Config.portalProdAPI
  }

  static getMAXFileSize(){
    return Config.MAX_FILE_ALLOWED
  }

  static getFileIcon(filename){
    let FileImageTypes = ['PNG', 'JPEG','JPG', 'TIFF', 'GIF', 'BMP', 'PPM', 'BAT', 'SVG', 'PSD']
    let FileArchiveTypes = ['zip', 'rar']
    let FileWord = ['docx', 'docm', 'doc', 'docb']
    let FileExcel = ['xls', 'xlsx', 'xlsm', 'xltm', 'xltx']
    let FilePowerpoint = ['pptx', 'pptm', 'ppt']
    let FileVideo = ['AVI', 'FLV', 'WMV', 'MOV', 'MP4', '3GPP']
    let FileText = ['txt']
    let FilePDF = ['pdf']
    var re = /(?:\.([^.]+))?$/g
    let file_name  = re.exec(filename)[1]
    if(typeof file_name != 'undefined'){
        if(FileArchiveTypes.includes(file_name)){
            return  'fa-file-archive archive-color'
            // return  'fa-file-archive theme-grey'
        }
        if(FileImageTypes.includes(file_name.toUpperCase())){
            return  'fa-file-image image-color'
            // return  'fa-file-image theme-orange'
        }

        if(FileWord.includes(file_name)){
            return  'fa-file-word word-color'
            // return  'fa-file-word theme-color'
        }

        if(FilePowerpoint.includes(file_name)){
            return  'fa-file-powerpoint powerpoint-color'
            // return  'fa-file-powerpoint theme-orange'
        }

        if(FileExcel.includes(file_name)){
            return  'fa-file-excel excel-color'
            // return  'fa-file-excel theme-green'
        }

        if(FileVideo.includes(file_name.toUpperCase())){
            return  'fa-file-video video-color'
            // return  'fa-file-video theme-red'
        }
        if(FilePDF.includes(file_name)){
            return  'fa-file-pdf pdf-color'
            // return  'fa-file-pdf theme-red'
        }

        if(FileText.includes(file_name)){
            return  'fa-file-alt file-color'
            // return  'fa-file-alt theme-grey'
        }
        return  'fa-file theme-grey'
      }
      return  'fa-file theme-grey'
    }

  static setSessionInvalid(session_invalid_status){
    sessionStorage.setItem('session_id_invalid', session_invalid_status)
    if(session_invalid_status){
      Global.logout()
    }
  }

  static isLoggedIn(){
    return isLoggedIn
  }

  static logout(){
    isLoggedIn = false
    UserApi.logout()
    Socket.close()
    Global.globalValue(VueSignals.SHOW_MODAL, false)
    Global.globalValue(VueSignals.IS_LOGGEDIN_USER, false)
    Global.globalValue(VueSignals.AUTHENTICATED, false)
    Global.globalValue(VueSignals.NOTIFICATION_NEED_PERMISSION, false)
    Global.removeAllCookiesExcept(['login_token', 'login_email', 'rememberPW'], true)
    router.push("login")
  }

  static setFaviconNormal() {
      ///////////@Changing favicon
      var link = document.querySelectorAll("link[rel*='icon']") ||  document.querySelectorAll("link[rel*='shortcut icon']") || document.createElement('link');
      link.forEach(currLink => {
        currLink.type = 'image/png';
        currLink.rel = 'shortcut icon';
        currLink.href ='/img/icons/favicon-32x32.png?v=' +  new Date()*1
        document.getElementsByTagName('head')[0].appendChild(currLink);
      })
    //////////////////////
  }

  static changeFaviconToAlert() {
    ///////////@Changing favicon
        var link = document.querySelectorAll("link[rel*='icon']") ||  document.querySelectorAll("link[rel*='shortcut icon']") || document.createElement('link');
        link.forEach(currLink => {
          currLink.type = 'image/png';
          currLink.rel = 'shortcut icon';
          currLink.href = '/img/icons/favicon_alert.png?v=' +  new Date()*1;
          document.getElementsByTagName('head')[0].appendChild(currLink);
        })
  //////////////////////
}

  static toByte(x, l=0){
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let n = parseInt(x, 10) || 0;
        while(n >= 1024 && ++l)
            n = n/1024;
        return(n.toFixed(n >= 10 || l < 1 ? 0 : 1) + ' ' + units[l]);
  }

  static removeAllCookies(){
    let cookies = $cookies.keys()
    for(let i=0; i<cookies.length;i++){
      $cookies.remove(cookies[i])
    }
    sessionStorage.clear()
    SessionManager.clear()
  }

  static removeAllCookiesExcept(arr, withMemeoryClear = true){
    let cookies = $cookies.keys()
    for(let i=0; i<cookies.length;i++){
      if(arr.indexOf(cookies[i])< 0){
        $cookies.remove(cookies[i])
      }
    }
    for(let item in sessionStorage){
      if(arr.indexOf(item) < 0){
        sessionStorage.removeItem(item)
        console.log(item + " has been removed")
      }
    }
    if(withMemeoryClear){
      SessionManager.clear()
    }
  }

  static getRootWindow(window){
      // if(window.parent === window){
      //     return window
      // }
      // return Global.getRootWindow(window.parent)
      if (window.location.href.indexOf('192.168') || window.parent === window) {
        return window
      }
      return Global.getRootWindow(window.parent)
  }

  static SetURLChannel(new_channel_id, channel_name){
    if(!Global.isDevelop()){
      document.domain = "cloudplan.net"
    }
    // same channel redirect
    if (router.history.current.name == 'channel' && router.history.current.params.id == new_channel_id) {
        return;
    }
    router.push({name: 'channel', params: {id: new_channel_id}});
  }

  static GetAvailabileLanguaes(){
    return Config.languages
  }

  static GetStaticChannelIds(){
    return Config.static_channel_ids
  }

  static Splash(status){
    if(status == 1 || status){
      Global.globalValue(VueSignals.SPLASH_SCREEN, true)
    }
    if(status == 0 || !status){
      Global.globalValue(VueSignals.SPLASH_SCREEN, false)
    }
  }

  static AddActionAnalytics(action){
    /** ActionAnalytics.push(action)
     @TODO Deactivate it for now */
    // if(ActionAnalytics.length > 5){
    //   UserApi.ActionAnalytics(ActionAnalytics)
    //   ActionAnalytics = []
    // }
  }


  static isLoggedInCookie(){
    if($cookies.isKey("loggedIn")){
      return $cookies.get("loggedIn")
    }
    return false
  }

  static getSessionIdCookie(){
    if($cookies.isKey("sessionId")){
      return $cookies.get("sessionId")
    }

    return ''
  }

  static getLoginTokenCookie(){
    if($cookies.isKey("login_token")){
      return $cookies.get("login_token")
    }
    return ''
  }

  static isURLPath(){
    let routesPathesPossability = []
    router.options.routes.forEach(currRoute => {
      if(currRoute.path != '/'){
        routesPathesPossability.push(currRoute.path)
      }
    })
    let activePath = window.location.pathname.replace(/\/|\\/g,'')
    for(let path in routesPathesPossability){
      let routePath = routesPathesPossability[path].replace(/\*|\//g, '')
      if(routePath == activePath){
        return  true
      }
    }
    return false
  }


  static DetectAgent(){
    if(typeof navigator.userAgent != 'undefined')
      clientAgent = navigator.userAgent.toLowerCase()
  }

  static isELectron(){
    if(clientAgent.indexOf('electron') > -1){
      return true
    }
    return false
  }

  /**
   * it evaluates URL and isolate , desktop application
   *                              , web portal
   *                              , chat
   * from being rendered to the view
   */
  static isSandBox(){
    let pageURL = new URL(window.location.href)
    for(let i=0; i<config.SAND_BOX_PATHES.length;i++){
      if(pageURL.pathname.indexOf(config.SAND_BOX_PATHES[i]) > -1){
        return true
      }
    }
    return false
  }

  static setOpenMenu(position){
    // if(position == 'left'){
    //   Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
    // }else if(position == 'right'){
    //   Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
    // }else {
    //   Global.globalValue(VueSignals.SHOW_LEFT_SIDEBAR_MOBILE, false)
    //   Global.globalValue(VueSignals.SHOW_RIGHT_SIDEBAR_MOBILE, false)
    // }

    setTimeout(function(){
      openMenuPosition = position
    }, 0)
  }

  static getOpenMenu(){
    return openMenuPosition
  }

  static isOpenMenu(){
    if(openMenuPosition != ''){
      return true
    }
    return false
  }


  static SetupSubFolder(parent_docs){
    let parent_paths = []
    for(let folder in parent_docs){
        parent_paths.push({
            "cp_id": parent_docs[folder].cp_id,
            "name": parent_docs[folder].name,
        })
    }
      Global.globalValue(VueSignals.ACTIVE_CHANNEL_PARENT_DOCS, parent_paths.reverse())
  }

  static SplashTimeout(historyLength){
    if(historyLength == 0){
      setTimeout(function(){
        Global.Splash(0)
      }, 60000)
    }
  }

  static setAlr(value){
      alr = value;
  }

  static getAlr(){
      return alr;
  }

  static getUserData(user_id) {
      if (user_id != SessionManager.getLoggedInUserId()) {
          let user = SessionManager.getUser(user_id);
          if (typeof user == 'undefined') {
              return;
          }
          let activeChannelDoc = SessionManager.getActiveChannel();
          if (activeChannelDoc.hasOwnProperty('removed_users')) {
              if (activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                  user.removed = true
              } else {
                  user.removed = false
              }
          }
          return user
      } else if (user_id == SessionManager.getLoggedInUserId()) {
          return SessionManager.getLoggedInUser()
      }
  }

  static getChannelPicture(channel) {
      if (channel.image_doc) {
          return channel.image_doc;
      } else if (channel.direct) {
          let user_id = channel.user_ids.filter(id => id !== SessionManager.getLoggedInUserId())[0];
          // Self channel
          if (!user_id) {
              user_id = channel.user_ids[0];
          }
          let user_picture = Global.getUserData(user_id).image_doc;
          return user_picture ? user_picture : Config.DEFAULT_USER_IMAGE;
      } else {
          return Config.DEFAULT_USER_IMAGE;
      }
  }

  static isMobileClientUsed() {
      try {
          // Xamarin function C#
          mobileClientVersion = window.top.invokeCSharpGetMobileClientVersion();
          return true;
      } catch (err) {
          return false;
      }
  }

  static getMobileVersion() {
      return mobileClientVersion;
  }

  static displayConventionalView() {
      if (SessionManager.getLoggedInUser().settings.show_preview_message || window.screen.width <= 900) {
          return true;
      } else {
          return false;
      }
  }

  static setFoldeContent(value) {
      folderContent = value;
  }

  static getFileFromFolder(file_id, channel_id) {
      let ff_elem = folderContent.find(currElem => {
          return currElem.cp_id == file_id
      });
      return ff_elem;
  }

  static getFileSize(file_id, channel_id) {
      let ff_elem = folderContent.find(currElem => {
          return currElem.cp_id == file_id
      })
      if (typeof ff_elem == 'undefined') {
          FileApi.Details(file_id, channel_id).then(res => {
              if (res.data.result) {
                  folderContent.push(res.data);
                  let size = Global.toByte(res.data.size);
                  // console.log('size1', size);
                  return size;
              } else {
                  return '0 kb';
              }
          })
      } else {
          if (ff_elem.hasOwnProperty('size')) {
              return Global.toByte(ff_elem.size);
          }
          if (ff_elem.file_size_b != 0) {
              return Global.toByte(ff_elem.file_size_b);
          }
          return Global.toByte(ff_elem.file_size_kb_estimate, 1);
      }
  }

}
